module.exports = __webpack_public_path__ + "static/media/Icon_B7DCAB.b4d78d11.png";